import { Button, Table } from "antd";
import { useDealer } from "../../../../tools/api";
import { ExportOutlined } from "@ant-design/icons";
import { NotFound } from "../../../../sources/svg/svg";
import { useEffect, useState } from "react";
import { Excel } from "antd-table-saveas-excel";
import { complexDigitToman, convertToGregorian, convertToJalaliWithTime } from "../../../../tools/tools";

const WalletTransaction = ({ search = [], type = 0, isActive = false }) => {
  const { queryWalletByDate } = useDealer();
  const [isLoadingList, setIsLoadingList] = useState(true);

  const cTable = [
    {
      title: "نام کاربری",
      dataIndex: "username",
      key: "username",
      width: 150,
    },
    {
      title: "تاریخ",
      dataIndex: "date",
      key: "date",
      width: 150,
    },
    {
      title: "شماره آپتل",
      dataIndex: "msisdn",
      key: "msisdn",
      width: 150,
    },
    {
      title: "نوع عملیات",
      dataIndex: "actionType",
      key: "actionType",
      width: 150,
    },
    {
      title: "بابت",
      dataIndex: "for",
      key: "for",
      width: 150,
    },
    {
      title: "مجموع برداشت (تومان)",
      dataIndex: "totalWithdrawal",
      key: "totalWithdrawal",
      width: 150,
    },
    {
      title: "مجموع واریزی(تومان)",
      dataIndex: "totalDeposit",
      key: "totalDeposit",
      width: 150,
    },
    {
      title: "موجودی (تومان)",
      dataIndex: "balance",
      key: "balance",
      width: 150,
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: 150,
    },
  ];
  const [bTable, setBTable] = useState([]);
  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  const handleExport = () => {
    const excel = new Excel();
    let tempTable = bTable.map((item) => {
      return {
        ...item,
        totalWithdrawal: item.totalWithdrawal.props.children,
        totalDeposit: item.totalDeposit.props.children,
        balance: item.balance.props.children,
      };
    });
    excel.addSheet("لیست کیف پول").addColumns(cTable).addDataSource(tempTable, { str2Percent: true }).saveAs("export.xlsx");
  };

  const handleSearch = async (value) => {
    try {
      setIsLoadingList(true);
      let payload = {
        wallettype: type,
        dateto: convertToGregorian(value[1], "-", "-"),
        datefrom: convertToGregorian(value[0], "-", "-"),
        searchconfigmodel: {
          sort: "",
          filter: "",
          entriesperpage: 10,
          page: currentPage === 0 ? 0 : currentPage - 1,
          totalrowcount: 0,
        },
      };
      let response = await queryWalletByDate(payload);
      if (response) {
        setBTable(
          response.Result.map((item, key) => ({
            key: key,
            username: item.userName,
            date: convertToJalaliWithTime(item.dtE_OperationDate),
            msisdn: item.telNoOne,
            actionType: item.stR_WalletType,
            for: item.stR_ChargeType,
            totalWithdrawal: <span dir="ltr">{item.inT_ChargeAmount < 0 ? complexDigitToman(item.inT_ChargeAmount) : 0}</span>,
            totalDeposit: <span dir="ltr">{item.inT_ChargeAmount > 0 ? complexDigitToman(item.inT_ChargeAmount) : 0}</span>,
            balance: (
              <span className="result-sucess" dir="ltr">
                {complexDigitToman(item.inT_WalletAmount)}
              </span>
            ),
          })),
        );
        setTotalRecord(response?.searchconfigmodel?.totalrowcount);
      }
      setIsLoadingList(false);
    } catch (error) {
      console.error(error);
      setIsLoadingList(false);
    }
  };
  useEffect(() => {
    const callServices = async () => {
      try {
        if (search) {
          console.log(search);
          handleSearch(search);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (isActive) {
      callServices();
    }
  }, [currentPage, search]);
  return (
    <>
      <div className="holder-top-table">
        <div className="holder-button">
          <Button onClick={handleExport} icon={<ExportOutlined />} className="btn-normal btn-print">
            {" "}
            خروجی اکسل{" "}
          </Button>
        </div>
      </div>

      <Table
        className="tbl-normal"
        columns={cTable}
        loading={isLoadingList}
        locale={{
          emptyText: (
            <>
              <NotFound text={"رکوردی یافت نشد."} />
            </>
          ),
        }}
        pagination={{
          className: "page-pagination",
          // position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
          onChange: (page) => {
            setCurrentPage(page);
          },
          pageSize: 10,
          align: "start",
          current: currentPage === 0 ? 1 : currentPage,
          total: totalRecord,
          showSizeChanger: false,
        }}
        scroll={{ y: "100%" }}
        dataSource={bTable}
      ></Table>
    </>
  );
};

export default WalletTransaction;
